let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cc1H3")).then(() => parcelRequire('bDSsV'));